import { z } from "zod";
export var formElementTypeSchema = z.union([z.literal("text"), z.literal("select"), z.literal("date"), z.literal("group")]);
export var formElementSchema = z.object({
    id: z.string(),
    type: formElementTypeSchema
});
//# sourceMappingURL=FormElement.zod.js.map